import React from 'react';
import { heroImageMap } from '../../data/serviceImages';

const SDHeroSection = ({ content, serviceSlug }) => {
  const heroImage = heroImageMap[serviceSlug] || 'https://images.unsplash.com/photo-1571846216028-962bc9269df8?q=80&w=2070';

  return (
    <section className="relative py-32 overflow-hidden" data-testid="sd-hero-section">
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${heroImage})` }}
      >
        <div className="absolute inset-0 bg-gradient-to-br from-[#1A3628]/90 via-[#11241A]/90 to-[#0D1910]/95"></div>
      </div>
      <div className="absolute inset-0 opacity-10"></div>
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <div className="inline-block mb-4">
            <p className="text-[#C85A40] text-sm font-bold uppercase tracking-wider px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full border border-white/20" style={{ textShadow: '0 2px 4px rgba(0,0,0,0.3)' }}>
              {content.category}
            </p>
          </div>
          <h1 className="font-display text-5xl md:text-6xl font-bold text-white mb-6 tracking-tighter leading-tight">
            {content.title}
          </h1>
          <p className="font-body text-base text-white/70 mb-10 max-w-4xl mx-auto leading-relaxed">
            {content.hero}
          </p>
        </div>
      </div>
    </section>
  );
};

export default SDHeroSection;
